var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2301_77971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.167 5.33301H5.83366C4.36699 5.33301 3.18033 6.53301 3.18033 7.99967L3.16699 23.9997C3.16699 25.4663 4.36699 26.6663 5.83366 26.6663H27.167C28.6337 26.6663 29.8337 25.4663 29.8337 23.9997V7.99967C29.8337 6.53301 28.6337 5.33301 27.167 5.33301ZM26.6337 10.9997L17.207 16.893C16.7803 17.1597 16.2203 17.1597 15.7937 16.893L6.36699 10.9997C6.03366 10.7863 5.83366 10.4263 5.83366 10.0397C5.83366 9.14634 6.80699 8.61301 7.56699 9.07967L16.5003 14.6663L25.4337 9.07967C26.1937 8.61301 27.167 9.14634 27.167 10.0397C27.167 10.4263 26.967 10.7863 26.6337 10.9997Z",
    fill: "#2E2B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2301_77971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.30bf61055f866a9af6d186b48c722a1e.svg";
export { ForwardRef as ReactComponent };